import { ScheduledSetting as ShowSetting, ScheduleMarker, ScheduleDraftStatus, useScheduledSettings } from './Scheduling/ScheduledSettings';
import { useControllerConnectionStatus } from '../Hooks/useControllerConnectionStatus';
import Typography from '@material-ui/core/Typography';

import Box from '@material-ui/core/Box';

import {
  EnableDisableDaytimeSelect,
  AbsoluteRelativeSelect,
  DehumidificationModeSelect,
  EnableDisableSelect
} from '../FormWidgets/Select.js';

import Desc from '../FormWidgets/Description';
import { SettingGroupBlock, SettingGroupGrid, ValueBox } from '../FormWidgets/SettingGroup';
import { LoadSettingsDialog } from '../Utils/load_settings';
import { useCo2Settings } from '../Hooks/useCo2Settings';
import { supportsCo2SettingsRelocation } from '../Utils/co2_utils';

import { SettingActions } from '../components';

export default function ClimateSettings({ ...other }) {
  const {
    t,
    controller,
    parent,
    controllerSnapshot,
    parentSnapshot,
    values: ordinaryValues,
    controls: ordinaryControls,
    openLoadSettingsDialog,
    closeLoadSettingsDialog,
    tab_id
  } = useCo2Settings();
  const schedule = useScheduledSettings(controller, parent, 'climate', ordinaryValues, ordinaryControls);
  const { values, controls } = schedule;
  const { status: connectionStatus, disabledReason: connectionDisabledReason } =
    useControllerConnectionStatus(controller);

  const write_access = controllerSnapshot.access_rights.climate.write;
console.log ('___climate_render__');
  return (
    <>
      <ScheduleDraftStatus schedule={schedule} />
      <LoadSettingsDialog
        open={openLoadSettingsDialog}
        handleClose={closeLoadSettingsDialog}
        controls={ordinaryControls}
      />

      {schedule.canSave && (
        <SettingActions
          title={connectionDisabledReason}
          on_default={schedule?.saving || connectionStatus !== 'good'}
          onSave={controls.saveSettings}
          onReset={controls.resetSettings}
        />
      )}

      <SettingGroupGrid controller={controllerSnapshot} id={'humidity_sp'}>
        <ShowSetting
          schedule={schedule}
          id="humidity_sp_day"
          controller={controllerSnapshot}
          cur_value={values.humidity_sp_day}
          controller_value={parentSnapshot.settings.climate.humidity_sp_day}
          controls={controls}
          disabled={
            values.vpd_calc_enable === 2 ||
            values.vpd_calc_enable === 1 ||
            values.vpd_calc_enable === -1 ||
            schedule.disabled('humidity_sp_day')
          }
        />
        <ShowSetting
          schedule={schedule}
          id="humidity_sp_night"
          controller={controllerSnapshot}
          cur_value={values.humidity_sp_night}
          controller_value={parentSnapshot.settings.climate.humidity_sp_night}
          controls={controls}
          disabled={values.vpd_calc_enable === 1 || values.vpd_calc_enable === -1 || schedule.disabled('humidity_sp_night')}
        />
      </SettingGroupGrid>

      <SettingGroupGrid controller={controllerSnapshot} id={'temp_sp'}>
        <ShowSetting
          schedule={schedule}
          id="temp_sp_day"
          controller={controllerSnapshot}
          cur_value={values.temp_sp_day}
          controller_value={parentSnapshot.settings.climate.temp_sp_day}
          cat={tab_id}
          controls={controls}
          disabled={schedule.disabled('temp_sp_day')}
          type="float"
        />
        <ShowSetting
          schedule={schedule}
          id="temp_sp_night"
          controller={controllerSnapshot}
          cur_value={values.temp_sp_night}
          controller_value={parentSnapshot.settings.climate.temp_sp_night}
          controls={controls}
          disabled={schedule.disabled('temp_sp_night')}
          type="float"
        />
        {supportsCo2SettingsRelocation(controllerSnapshot) && (
          <ShowSetting
            schedule={schedule}
            id="temp_sp_co2"
            controller={controllerSnapshot}
            cur_value={values.temp_sp_co2}
            controller_value={parentSnapshot.settings.climate.temp_sp_co2}
            controls={controls}
            disabled={schedule.disabled('temp_sp_co2')}
            type="float"
          />
        )}
      </SettingGroupGrid>

      <SettingGroupGrid controller={controllerSnapshot} id={'vapour_pressure_deficit_vpd'}>
        <ShowSetting
          schedule={schedule}
          id="vpd_sp"
          controller={controllerSnapshot}
          cur_value={values.vpd_sp}
          controller_value={parentSnapshot.settings.climate.vpd_sp}
          unit={controllerSnapshot.settings.system.vpd_format === 0 ? 'hPa' : 'kPa'}
          num_digits={controllerSnapshot.settings.system.vpd_format === 0 ? 1 : 2}
          mod_digits={controllerSnapshot.settings.system.vpd_format === 0 ? 1 : 10}
          controls={controls}
          type="float"
        disabled={schedule.disabled('vpd_sp')}
        />
        <ShowSetting
          schedule={schedule}
          id="vpd_sp_night"
          controller={controllerSnapshot}
          cur_value={values.vpd_sp_night}
          controller_value={parentSnapshot.settings.climate.vpd_sp_night}
          unit={controllerSnapshot.settings.system.vpd_format === 0 ? 'hPa' : 'kPa'}
          num_digits={controllerSnapshot.settings.system.vpd_format === 0 ? 1 : 2}
          mod_digits={controllerSnapshot.settings.system.vpd_format === 0 ? 1 : 10}
          controls={controls}
          type="float"
        disabled={schedule.disabled('vpd_sp_night')}
        />
        <ValueBox controller={controllerSnapshot} id={'climate_vpd_calc_enable'}>
          <Typography gutterBottom>
            <ScheduleMarker target={schedule('vpd_calc_enable')} />
            <Desc id="vpd_calc_enable" name="VPD Calculation Enable" />
          </Typography>
          <EnableDisableDaytimeSelect controls={controls}
            value={values.vpd_calc_enable}
            controller_value={parentSnapshot.settings.climate.vpd_calc_enable}
            name="vpd_calc_enable"
            onChange={(event, value) => controls.setValue('vpd_calc_enable', event.target.value)}
            disabled={schedule.disabled('vpd_calc_enable')}
          />
        </ValueBox>
      </SettingGroupGrid>

      <SettingGroupGrid controller={controllerSnapshot} id={'preheat_night_day'}>
        <ShowSetting
          schedule={schedule}
          id="preheat_night_day"
          controller={controllerSnapshot}
          cur_value={values.preheat_night_day}
          controller_value={parentSnapshot.settings.climate.preheat_night_day}
          controls={controls}
          disabled={schedule.disabled('preheat_night_day')}
        />
      </SettingGroupGrid>

      {/* Changed Version-Guard from ADE -> ADED since older controls where incorrectly shiped with ADED. */}
      {controllerSnapshot.api_version <= 'ADED' && (
        <SettingGroupGrid controller={controllerSnapshot} id={'temp_sp_heater'}>
          <ShowSetting
            schedule={schedule}
            id="temp_sp_heater_day"
            controller={controllerSnapshot}
            cur_value={values.temp_sp_heater_day}
            controller_value={parentSnapshot.settings.climate.temp_sp_heater_day}
            max={values.temp_sp_day / 10 - 1}
            controls={controls}
            disabled={schedule.disabled('temp_sp_heater_day')}
            type="float"
            off_at={49}
          />
          <ShowSetting
            schedule={schedule}
            id="temp_sp_heater_night"
            controller={controllerSnapshot}
            cur_value={values.temp_sp_heater_night}
            controller_value={parentSnapshot.settings.climate.temp_sp_heater_night}
            max={values.temp_sp_night / 10 - 1}
            controls={controls}
            disabled={schedule.disabled('temp_sp_heater_night')}
            type="float"
          />
        </SettingGroupGrid>
      )}

      <SettingGroupBlock label={t('temperature_setpoint_heating_mat')}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
          <ValueBox controller={controllerSnapshot} id={'climate_toggle_temp_heating_mat_day'}>
            <Typography gutterBottom>
              <ScheduleMarker target={schedule('toggle_temp_heating_mat_day')} />
              <Desc id="toggle_temp_heating_mat_day" />
            </Typography>
            <AbsoluteRelativeSelect controls={controls}
              value={values.toggle_temp_heating_mat_day}
              controller_value={parentSnapshot.settings.climate.toggle_temp_heating_mat_day}
              name="toggle_temp_heating_mat_day"
              onChange={(event, value) =>
                controls.setValue('toggle_temp_heating_mat_day', event.target.value)
              }
              disabled={schedule.disabled('toggle_temp_heating_mat_day')}
            />
          </ValueBox>
          <ValueBox controller={controllerSnapshot} id={'climate_toggle_temp_heating_mat_night'}>
            <Typography gutterBottom>
              <ScheduleMarker target={schedule('toggle_temp_heating_mat_night')} />
              <Desc id="toggle_temp_heating_mat_night" />
            </Typography>
            <AbsoluteRelativeSelect controls={controls}
              value={values.toggle_temp_heating_mat_night}
              controller_value={parentSnapshot.settings.climate.toggle_temp_heating_mat_night}
              name="toggle_temp_heating_mat_night"
              onChange={(event, value) =>
                controls.setValue('toggle_temp_heating_mat_night', event.target.value)
              }
              disabled={schedule.disabled('toggle_temp_heating_mat_night')}
            />
          </ValueBox>
        </Box>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'stretch' }}>
          {values.toggle_temp_heating_mat_day === 1 ? (
            <ShowSetting
              schedule={schedule}
              id="temp_sp_heating_mat_day_abs"
              controller={controllerSnapshot}
              cur_value={values.temp_sp_heating_mat_day_abs}
              controller_value={parentSnapshot.settings.climate.temp_sp_heating_mat_day_abs}
              controls={controls}
              disabled={schedule.disabled('temp_sp_heating_mat_day_abs')}
              type="float"
            />
          ) : (
            <ShowSetting
              schedule={schedule}
              id="temp_sp_heating_mat_day_rel"
              controller={controllerSnapshot}
              cur_value={values.temp_sp_heating_mat_day_rel}
              controller_value={parentSnapshot.settings.climate.temp_sp_heating_mat_day_rel}
              controls={controls}
              disabled={schedule.disabled('temp_sp_heating_mat_day_rel')}
              type="float"
            />
          )}
          {values.toggle_temp_heating_mat_night === 1 ? (
            <ShowSetting
              schedule={schedule}
              id="temp_sp_heating_mat_night_abs"
              controller={controllerSnapshot}
              cur_value={values.temp_sp_heating_mat_night_abs}
              controller_value={parentSnapshot.settings.climate.temp_sp_heating_mat_night_abs}
              controls={controls}
              disabled={schedule.disabled('temp_sp_heating_mat_night_abs')}
              type="float"
            />
          ) : (
            <ShowSetting
              schedule={schedule}
              id="temp_sp_heating_mat_night_rel"
              controller={controllerSnapshot}
              cur_value={values.temp_sp_heating_mat_night_rel}
              controller_value={parentSnapshot.settings.climate.temp_sp_heating_mat_night_rel}
              controls={controls}
              disabled={schedule.disabled('temp_sp_heating_mat_night_rel')}
              type="float"
            />
          )}
        </Box>
      </SettingGroupBlock>

      <SettingGroupGrid controller={controllerSnapshot} id={'dehumidification_hl'}>
        <ValueBox controller={controllerSnapshot} id={'climate_dehumidification_mode'}>
          <Typography gutterBottom>
            <Desc id="dehumidification_mode" name="Select Dehumidification Mode" />
          </Typography>
          <DehumidificationModeSelect controls={controls}
            value={values.dehumidification_mode}
            controller_value={parentSnapshot.settings.climate.dehumidification_mode}
            name="dehumidification_mode"
            onChange={(event, value) =>
              controls.setValue('dehumidification_mode', event.target.value)
            }
            disabled={!write_access}
          />
        </ValueBox>
        <ValueBox controller={controllerSnapshot} id={'climate_heating_to_dehumidify_en'}>
          <Typography gutterBottom>
            <Desc id="heating_to_dehumidify_en" />
          </Typography>
          <EnableDisableSelect controls={controls}
            value={values.heating_to_dehumidify_en}
            controller_value={parentSnapshot.settings.climate.heating_to_dehumidify_en}
            name="heating_to_dehumidify_en"
            onChange={(event, value) =>
              controls.setValue('heating_to_dehumidify_en', event.target.value)
            }
            disabled={!write_access}
          />
        </ValueBox>
      </SettingGroupGrid>

      {schedule.canSave && (
        <SettingActions
          title={connectionDisabledReason}
          on_default={schedule?.saving || connectionStatus !== 'good'}
          onSave={controls.saveSettings}
          onReset={controls.resetSettings}
        />
      )}
    </>
  );
}
